import React from 'react'

const CategoryStatistics = ({ t, lang, category }) => {
  return (
    <div className="chart-card">
      <div className="chart-card-header">
        <strong>{t("categoryStatistics")}</strong>
        <i class="fas fa-ellipsis-vertical d-none"></i>
      </div>
      <div className="chart-card-body mt-1">
        <table className="table">
          <thead>
            <tr>
              <th>{t("category")}</th>
              <th>{t("numberOfTrips")}</th>
              <th>{t("noOfBookings")}</th>
              <th>{t("revenue")}</th>
            </tr>
          </thead>
          <tbody>
            {category?.map((item, index) => (
              <tr key={index}>
                <td>{item?.name[lang]}</td>
                <td>{item?.noOfTrips}</td>
                <td>{item?.noOfBookings}</td>
                <td>{item?.revenue}</td>
                </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default CategoryStatistics